import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import { css } from '@emotion/core';
import {
    FacebookShareButton,
    LineShareButton,
    TwitterShareButton,
    WhatsAppShareButton
} from 'client/components/Result/Share/button';
import { system900 } from 'Mui/styles/color';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { Typography } from '@material-ui/core';
const DialogShareButtonGroup = ({ open, onClose, url }) => {
    if (!open) return null;

    const shareButtons = [
        { Comp: LineShareButton, key: 'line' },
        { Comp: FacebookShareButton, key: 'facebook' },
        { Comp: WhatsAppShareButton, key: 'whatsapp' },
        { Comp: TwitterShareButton, key: 'twitter' }
    ];
    return (
        <div css={overlayStyle}>
            <div css={containerWrapperStyle}>
                <div css={headerStyle}>
                    <Typography variant="h6">{i18n.t('btn.other_share')}</Typography>
                    <div css={css(closeContainerStyle)}>
                        <IconButton aria-label="close" onClick={onClose} size="small">
                            <CloseIcon css={css(closeIconStyle)} />
                        </IconButton>
                    </div>
                </div>
                <div css={containerStyle}>
                    {shareButtons.map(({ Comp, key }) => (
                        <div css={buttonWrapper} key={key}>
                            <Comp url={url} />
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default DialogShareButtonGroup;

DialogShareButtonGroup.propTypes = {
    open: PropTypes.bool,
    onClose: PropTypes.func,
    url: PropTypes.string.isRequired
};

const overlayStyle = css`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: #00000099;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    z-index: 1000;
`;

const containerWrapperStyle = css`
    background: #fff;
    padding: 16px;
    border-radius: 0 0 12px 12px;
    width: 100%;
    max-width: 400px;
`;

const headerStyle = css`
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 16px;
    position: relative;
`;

const containerStyle = css`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
    margin-bottom: 8px;
`;

const buttonWrapper = css`
    width: 65px;
    min-width: 65px;
`;

const closeContainerStyle = css`
    position: absolute;
    right: 0px;
    top: 0px;
`;

const closeIconStyle = css`
    color: ${system900.color};
`;
